var table_viewer_default = {
  "viewMode": "bGoW3",
  "editMode": "tzCD5",
  "container": "_--eBg",
  "cell": "dxdT4"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
